import RIOApplicationHeader from '@rio-cloud/rio-uikit/ApplicationHeader';
import BrandLabel from 'features/main-navigation/BrandLabel';

import './_styles.scss';

export interface NavItem {
    key: string;
    route: React.ReactNode;
}

interface MainNavigationProps {
    showHomeIcon?: boolean;
    homeRoute?: React.ReactNode;
    navItems?: NavItem[];
    actionBarItems?: React.ReactNode[];
}

const MainNavigation = ({ showHomeIcon, homeRoute, navItems, actionBarItems }: MainNavigationProps) => (
    <RIOApplicationHeader
        showHomeIcon={showHomeIcon}
        homeRoute={homeRoute}
        navItems={navItems}
        actionBarItems={actionBarItems}
        label={<BrandLabel />}
        className='[&_.ModuleNavigation-dropdown]:pointer-events-auto [&_.ModuleNavigation]:pointer-events-auto [&_.navbar-brand]:border-none'
    />
);

export default MainNavigation;
